var _a;
import { PaymentOption } from './PaymentOptions';
export var SubHeaderByOption = (_a = {},
    _a[PaymentOption.CUSTOM] = 'Pay Custom Amount',
    _a[PaymentOption.SELECT_INVOICES] = 'Select Invoices To Pay',
    _a[PaymentOption.DUE_THIS_WEEK] = 'Pay Balance Due This Week',
    _a[PaymentOption.ALL] = 'Pay Entire Balance',
    _a);
